import React from 'react';
import { Hidden } from 'react-grid-system';
import { HeaderPartnerDetails } from "../HeaderPartnerDetails";
import InstallCount from "../InstallCount";
import { AppDetailsContainer, AppName, CertificationContainer, CompatibilitiesContainer, HeaderContainer, HeaderInjectionContainer, IconContainer, InstallCountContainer, RatingsContainer, TrustSignalsContainer, TrustSignalsRow } from "./AppHeader.styles";
import HeaderAppIcon, { getAppIcon } from "./components/HeaderAppIcon";
import HeaderCertificationBadge from "./components/HeaderCertificationBadge";
import HeaderLozenges from "./components/HeaderLozenges";
import HeaderRatings from "./components/HeaderRatings";

function AppHeader({
  appHeaderDetails,
  appIconLink,
  appIconSize = 'large',
  appRatingLink,
  bottomSeparator = true,
  compatibilitySummary = null,
  headerInjection,
  isAppCloudFortified = false,
  lozenges = [],
  openMarketplaceLinksInNewTab = true,
  showInstallationCount = false,
  bugBountyParticipant = null
}) {
  var _appHeaderDetails$com;

  return /*#__PURE__*/React.createElement(HeaderContainer, {
    bottomSeparator: bottomSeparator
  }, /*#__PURE__*/React.createElement(IconContainer, null, /*#__PURE__*/React.createElement(HeaderAppIcon, {
    size: appIconSize,
    origin: appHeaderDetails.origin,
    icon: appHeaderDetails.icon,
    appKey: appHeaderDetails.key,
    appIconLink: appIconLink
  })), /*#__PURE__*/React.createElement(AppDetailsContainer, null, /*#__PURE__*/React.createElement(AppName, null, appHeaderDetails.name), /*#__PURE__*/React.createElement(HeaderPartnerDetails, {
    name: appHeaderDetails.partner.name,
    link: appHeaderDetails.partner.link,
    openMarketplaceLinksInNewTab: openMarketplaceLinksInNewTab,
    partnerTierType: appHeaderDetails.partner.partnerTierType
  }), compatibilitySummary && /*#__PURE__*/React.createElement(Hidden, {
    xs: true
  }, /*#__PURE__*/React.createElement(CompatibilitiesContainer, null, compatibilitySummary))), /*#__PURE__*/React.createElement(TrustSignalsContainer, null, /*#__PURE__*/React.createElement(TrustSignalsRow, null, /*#__PURE__*/React.createElement(RatingsContainer, null, /*#__PURE__*/React.createElement(HeaderRatings, {
    appKey: appHeaderDetails.key,
    appRatingLink: appRatingLink,
    openMarketplaceLinksInNewTab: openMarketplaceLinksInNewTab,
    ratings: appHeaderDetails.ratings
  })), showInstallationCount && /*#__PURE__*/React.createElement(InstallCountContainer, null, /*#__PURE__*/React.createElement(InstallCount, {
    createdAt: appHeaderDetails.createdAt,
    distribution: appHeaderDetails.distribution,
    compatibleProducts: (_appHeaderDetails$com = appHeaderDetails.compatibleProducts) !== null && _appHeaderDetails$com !== void 0 ? _appHeaderDetails$com : []
  })), /*#__PURE__*/React.createElement(CertificationContainer, null, /*#__PURE__*/React.createElement(HeaderCertificationBadge, {
    appKey: appHeaderDetails.key,
    isAppCloudFortified: isAppCloudFortified,
    bugBountyParticipant: bugBountyParticipant
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(HeaderLozenges, {
    lozenges: lozenges
  }))), !!headerInjection && /*#__PURE__*/React.createElement(HeaderInjectionContainer, null, headerInjection));
}

AppHeader.getAppIcon = getAppIcon;
export default AppHeader;